/**
 * AutoTranslatedForumBody — translates a markdown forum body before
 * handing it to `renderForumBody`. Renders the source verbatim when the
 * active UI language is English or when translation is still in flight.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Languages, Loader2 } from 'lucide-react';
import { useAutoTranslate } from '../../hooks/useAutoTranslate';
import { renderForumBody } from './renderForumBody';

const AutoTranslatedForumBody = ({ text, testid = 'auto-forum-body' }) => {
  const { t } = useTranslation();
  const { translated, isTranslating, isTranslated } = useAutoTranslate(text || '');
  return (
    <div data-testid={testid}>
      {(isTranslating || isTranslated) && (
        <div className="mb-1">
          <span
            className="inline-flex items-center gap-1 rounded-full border border-primary/30 bg-primary/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-primary"
            data-testid={`${testid}-badge`}
          >
            {isTranslating ? (
              <>
                <Loader2 className="w-3 h-3 animate-spin" />
                {t('common.translating', 'Translating…')}
              </>
            ) : (
              <>
                <Languages className="w-3 h-3" />
                {t('common.translated', 'Translated')}
              </>
            )}
          </span>
        </div>
      )}
      {renderForumBody(translated || text)}
    </div>
  );
};

export default AutoTranslatedForumBody;
